
    <div class="email-settings-step">
        <form ref="form" @submit.prevent>
            <h4 class="my-3"><b>Email Settings</b></h4>

            <!-- Recipients Section -->
            <div class="form-group mb-4">
                <label>Recipients <span class="text-danger">*</span></label>
                <!-- Search Bar with Floating Dropdown -->
                <div class="recipient-search-wrapper recipent-field " style="position: relative;">
                    <v-menu v-model="menuOpen" offset-y :close-on-content-click="false" max-height="400"
                        nudge-bottom="5" content-class="recipient-dropdown-content">
                        <template v-slot:activator="{ on, attrs }">
                            <div ref="searchWrapper" class="search-container position-relative" v-bind="attrs"
                                v-on="on">
                                <CInput class="search-bar" v-model="memberQuery" @input="handleInput"
                                    @focus="menuOpen = true" placeholder="Search Team Member by name" type="text">
                                </CInput>
                                <v-icon small class="bg-white position-absolute p-2"
                                    style="right: 0.8rem; top: 4px;max-width:100%!important"
                                    color="rgba(79, 79, 79, 1)">mdi-magnify</v-icon>
                            </div>
                        </template>

                        <!-- Dropdown List -->
                        <div class="bg-white shadow-sm border rounded">
                            <div class="mx-3 my-2" ref="scrollableMembers" style="max-height: 300px; overflow: auto">
                                <!-- Header inside dropdown (Optional but useful context) -->
                                <div v-if="organizationName" class="px-2 py-2 d-none">
                                    <b>{{ organizationName }} Members</b>
                                    <hr class="my-2" />
                                </div>

                                <div v-for="item in filteredMembers" :key="item.id"
                                    style="border-bottom: 1px solid #E0E0E0;border-radius: 0px!important;"
                                    class="text-dark d-flex justify-content-between align-items-center my-1 px-3 py-2 rounded">
                                    <div class="d-flex flex-column" style="overflow: hidden;">
                                        <p class="m-0 text-truncate" style="font-size: 14px; color: #3F3F3F">{{
                                            item.name }}
                                        </p>
                                        <p class="m-0 font-weight-bold text-capitalize"
                                            style="font-size: 12px; color: #3F3F3F">
                                            {{
                                                toTitleCase(item.role) }}</p>
                                    </div>
                                    <div v-if="isSelected(item.id)" class="ml-2 btn btn-sm btn-danger py-1 px-3"
                                        style="font-size: 12px;" role="button" @click="removeRecipientById(item.id)">
                                        Remove
                                    </div>
                                    <div v-else class="ml-2 btn btn-sm btn-primary py-1 px-3" style="font-size: 12px;"
                                        role="button" @click="addRecipient(item)">Add</div>
                                </div>
                                <p class="text-center text-secondary my-2"><i>Don’t see the team member in the list? Type their name to search.</i></p>

                                <!-- States -->
                                <div class="my-4 text-center text-muted" v-if="members.length === 0 && !loadingMembers">
                                    <small>Member(s) not found</small>
                                </div>
                                <div class="my-4 text-center" v-if="loadingMembers">
                                    <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                                </div>
                            </div>
                        </div>
                    </v-menu>
                </div>

                <!-- Selected Recipients Chips -->
                <div class="counter mt-3" v-if="formData.recipients && formData.recipients.length > 0">
                    {{ formData.recipients.length }} member(s) selected. <span class="text-danger" role="button"
                        @click="removeAllRecipients"><b>Remove All</b></span>
                </div>
                <div v-if="formData.recipients && formData.recipients.length > 0" class="d-flex flex-wrap mt-3">
                    <v-tooltip
                        v-for="(recipient, index) in formData.recipients"
                        :key="index"
                        top
                        :attach="true"
                        :disabled="!isRecipientInactive(recipient)"
                        content-class="recipient-status-tooltip"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                v-bind="attrs"
                                v-on="on"
                                class="d-flex contributor-box mr-2 mb-2"
                                :class="recipientBoxClass(recipient)"
                            >
                                <div class="mr-3 align-self-center">
                                    <div style="color: #3F3F3F; font-weight: 700; font-size: 14px;">{{ recipient.name }}</div>
                                    <div class="my-1"
                                        style="color: #3F3F3F; font-size: 12px; font-weight: 400;">
                                        {{ normalizeEmail(recipient?.email) }}
                                    </div>
                                </div>
                                <div class="ml-auto close-btn" role="button" @click="removeRecipient(index)">
                                    <v-icon small color="#757575">mdi-close</v-icon>
                                </div>
                            </div>
                        </template>
                        <span>This team member is inactive. This report will no longer be sent to them.</span>
                    </v-tooltip>
                </div>
                <div v-else class="text-muted font-italic mt-3 mb-4">
                    No Recipient added
                </div>
                <small v-if="validationErrors.recipients" class="text-danger d-block mt-1">{{
                    validationErrors.recipients }}</small>
            </div>

            <!-- Header Logo Selection -->
            <div class="form-group mb-4">
                <label>Header Logo</label>
                <select v-model="formData.header_logo" disabled class="form-control" style="width: 800px;">
                    <option v-for="opt in logoOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                </select>
                <!-- Logo Preview -->
                <div v-if="currentLogoUrl" class="mt-2 text-center border rounded p-3" style="background: #f8f9fa;">
                    <img :src="currentLogoUrl" alt="Header Logo" style="max-width: 280px; max-height: 60px;">
                </div>
            </div>

            <!-- Subject -->
            <div class="form-group mb-4">
                <label class="">Subject <span class="text-danger">*</span></label>
                <CInput v-model="formData.subject" placeholder="Input email subject" required />
            </div>

            <!-- Body (Rich Text Editor) -->
            <div class="form-group mb-4">
                <label>Body <span class="text-danger">*</span></label>
                <small v-if="validationErrors.body" class="text-danger d-block mb-1">{{ validationErrors.body }}</small>
                <div class="email-body-editor">
                    <VueEditor ref="editor" v-model="formData.body" :editorToolbar="customToolbar"
                        :editorOptions="editorOptions" @ready="onEditorReady" placeholder="Dear Recipient,

Your scheduled report has been successfully generated and is now part of your reporting subscription..." />
                    <div v-if="isUploading" class="upload-overlay">
                        <div class="upload-spinner"></div>
                        <span>Uploading...</span>
                    </div>
                </div>
            </div>
            <div class="mb-4 pb-2" style="width: 100%;border-bottom: 1px solid #ccc;cursor: default!important;">
                <label>Attachment</label>
                <div class="mb-2" style="background-color: #EDF4FE; padding: 10px; border-radius: 5px; width: 100%  ;">
                    <span class="mdi mdi-file-document-outline"></span>
                    <span class="ml-2">{{ reportFilename }}</span>
                </div>

                <span class="text-muted">The filename will include the generation date automatically</span>
            </div>
        </form>
    </div>
